import styled from 'styled-components';
const Loader = styled.div `
  div {
    display: block !important;
  }
`;
export const Styled = {
    Loader,
};
